import Axios from "axios";
import {
    SET_SUPPLIER_LIST,
    UNSET_SUPPLIER_LIST
  } from "@/store/mutation-types";
import { saveUpdateSupplier, getSupplierList } from "@/store/api";
// initial state
const state = {
  getSupplierList: [],
  editingSupplier: null,
};

const getters = {
  getSupplierList(state) {
    return state.getSupplierList;
  },
  getEditingSupplier: (state) => state.editingSupplier,
};

const mutations = {
  [SET_SUPPLIER_LIST](state, data) {
    state.getSupplierList = data;
  },
  [UNSET_SUPPLIER_LIST](state) {
    state.getSupplierList = [];
  },
  setEditingSupplier(state, supplier) {
    state.editingSupplier = supplier;
  },
  clearEditingSupplier(state) {
    state.editingSupplier = null;
  }
};

const actions = {

  saveUpdateSupplier({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSupplier, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSupplierList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSupplierList, data)
        .then(function (response) {
          commit('SET_SUPPLIER_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SUPPLIER_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getSupplierById({ commit }, data) {
    const getSupplierById = `${getSupplierList}/${data}`;
    commit("SET_LOADING", {color: "primary"});  
    return new Promise((resolve, reject) => {
      Axios.get(getSupplierById)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getGeneratedSupplierCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generateSupplierCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
